// tslint:disable:max-file-line-count
import { mergeStyles } from '@cian/components';
import * as React from 'react';

import {
  ICommercialBuildingInfrastructureSchema,
  IOfferSchema,
} from '@cian/api-models/offer-card/v1/get-offer-data';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import * as styles from './index.css';

export interface IInfrastructureProps {
  offer: IOfferSchema;
}

interface IInfrastructureList {
  className: string;
  name: string;
}

export class Infrastructure extends React.Component<IInfrastructureProps, {}> {
  public render() {
    if (!this.props.offer.building) {
      return null;
    }

    const offerType = getOfferType(this.props.offer);
    const isCommercialCard = isCommercial(offerType);

    if (!isCommercialCard) {
      return null;
    }

    const infrastructureItems = getInfrastructureByOffer(
      this.props.offer.building
        ? this.props.offer.building.infrastructure
        : null,
    );

    if (infrastructureItems.length === 0) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>Инфраструктура</div>
        {
          infrastructureItems.map((infrastructureItem, index) => {
            return (
              <div {...mergeStyles([
                  styles['item'],
                  styles[infrastructureItem.className],
                ])}
                key={`infrastructureItem_${index}`}
              >
                {infrastructureItem.name}
              </div>
            );
          })
        }
      </div>
    );
  }
}

function getInfrastructureByOffer(
  infrastructureBuilding: ICommercialBuildingInfrastructureSchema | null,
): IInfrastructureList[] {
  const infrastructureForBuilding: IInfrastructureList[] = [];

  /**
   * Инфраструктура из поля offer.building.infrastructure
   */
  if (infrastructureBuilding) {
    if (infrastructureBuilding.hasOfficeSpace) {
      infrastructureForBuilding.push({
        className: 'office_space',
        name: 'Офисные помещения',
      });
    }

    if (infrastructureBuilding.hasAquapark) {
      infrastructureForBuilding.push({
        className: 'aquapark',
        name: 'Аквапарк',
      });
    }

    if (infrastructureBuilding.hasBabySitting) {
      infrastructureForBuilding.push({
        className: 'baby_sitting',
        name: 'Беби-ситинг',
      });
    }

    if (infrastructureBuilding.hasBowling) {
      infrastructureForBuilding.push({
        className: 'bowling',
        name: 'Боулинг',
      });
    }

    if (infrastructureBuilding.hasSlotMachines) {
      infrastructureForBuilding.push({
        className: 'slot_machines',
        name: 'Игровые автоматы',
      });
    }

    if (infrastructureBuilding.hasRink) {
      infrastructureForBuilding.push({
        className: 'rink',
        name: 'Каток',
      });
    }

    if (infrastructureBuilding.hasInspectionPit) {
      infrastructureForBuilding.push({
        className: 'inspection_pit',
        name: 'Смотровая яма',
      });
    }

    if (infrastructureBuilding.hasVideoSurveillance) {
      infrastructureForBuilding.push({
        className: 'video_surveillance',
        name: 'Видеонаблюдение',
      });
    }

    if (infrastructureBuilding.hasHourSecurity) {
      infrastructureForBuilding.push({
        className: 'hour_security',
        name: 'Круглосуточная охрана',
      });
    }

    if (infrastructureBuilding.hasAutomaticGates) {
      infrastructureForBuilding.push({
        className: 'automatic_gates',
        name: 'Автоматические ворота',
      });
    }

    if (infrastructureBuilding.hasEntryByPass) {
      infrastructureForBuilding.push({
        className: 'entry_by_pass',
        name: 'Въезд по пропускам',
      });
    }

    if (infrastructureBuilding.hasBasement) {
      infrastructureForBuilding.push({
        className: 'basement',
        name: 'Подвал/погреб',
      });
    }

    if (infrastructureBuilding.hasTire) {
      infrastructureForBuilding.push({
        className: 'tire',
        name: 'Шиномонтаж',
      });
    }

    if (infrastructureBuilding.hasStudio) {
      infrastructureForBuilding.push({
        className: 'studio',
        name: 'Фотосалон',
      });
    }

    if (infrastructureBuilding.hasClothesStudio) {
      infrastructureForBuilding.push({
        className: 'clothes_studio',
        name: 'Ателье одежды',
      });
    }

    if (infrastructureBuilding.hasHotel) {
      infrastructureForBuilding.push({
        className: 'hotel',
        name: 'Гостиница',
      });
    }

    if (infrastructureBuilding.hasMedicalCenter) {
      infrastructureForBuilding.push({
        className: 'medical_center',
        name: 'Медицинский центр',
      });
    }

    if (infrastructureBuilding.hasPharmacy) {
      infrastructureForBuilding.push({
        className: 'pharmacy',
        name: 'Аптека',
      });
    }

    if (infrastructureBuilding.hasCarService) {
      infrastructureForBuilding.push({
        className: 'car_service',
        name: 'Автосервис',
      });
    }

    if (infrastructureBuilding.hasMinimarket) {
      infrastructureForBuilding.push({
        className: 'minimarket',
        name: 'Минимаркет',
      });
    }

    if (infrastructureBuilding.hasWarehouse) {
      infrastructureForBuilding.push({
        className: 'warehouse',
        name: 'Складские помещения',
      });
    }

    if (infrastructureBuilding.hasCarWash) {
      infrastructureForBuilding.push({
        className: 'car_wash',
        name: 'Автомойка',
      });
    }

    if (infrastructureBuilding.hasConferenceRoom) {
      infrastructureForBuilding.push({
        className: 'conference_room',
        name: 'Конференц-зал',
      });
    }

    if (infrastructureBuilding.hasSupermarket) {
      infrastructureForBuilding.push({
        className: 'supermarket',
        name: 'Супермаркет',
      });
    }

    if (infrastructureBuilding.hasCanteen) {
      infrastructureForBuilding.push({
        className: 'canteen',
        name: 'Столовая',
      });
    }

    if (infrastructureBuilding.hasAtm) {
      infrastructureForBuilding.push({
        className: 'atm',
        name: 'Банкомат',
      });
    }

    if (infrastructureBuilding.hasPark) {
      infrastructureForBuilding.push({
        className: 'park',
        name: 'Парк',
      });
    }

    if (infrastructureBuilding.hasFitnessCentre) {
      infrastructureForBuilding.push({
        className: 'fitness_centre',
        name: 'Фитнес-центр',
      });
    }

    if (infrastructureBuilding.hasCentralReception) {
      infrastructureForBuilding.push({
        className: 'central_reception',
        name: 'Центральная рецепция',
      });
    }

    if (infrastructureBuilding.hasShoppingArea) {
      infrastructureForBuilding.push({
        className: 'shopping_area',
        name: 'Торговая зона',
      });
    }

    if (infrastructureBuilding.hasBankDepartment) {
      infrastructureForBuilding.push({
        className: 'bank_department',
        name: 'Отделение банка',
      });
    }

    if (infrastructureBuilding.hasFoodCourt) {
      infrastructureForBuilding.push({
        className: 'food_court',
        name: 'Фуд-корт',
      });
    }

    if (infrastructureBuilding.hasBeautyShop) {
      infrastructureForBuilding.push({
        className: 'beauty_shop',
        name: 'Салон красоты',
      });
    }

    if (infrastructureBuilding.hasGameRoom) {
      infrastructureForBuilding.push({
        className: 'game_room',
        name: 'Игровая комната',
      });
    }

    if (infrastructureBuilding.hasExhibitionAndWarehouseComplex) {
      infrastructureForBuilding.push({
        className: 'exhibition_and_warehouse_complex',
        name: 'Выставочно-складской комплекс',
      });
    }

    if (infrastructureBuilding.hasBuffet) {
      infrastructureForBuilding.push({
        className: 'buffet',
        name: 'Буфет',
      });
    }

    if (infrastructureBuilding.hasCinema) {
      infrastructureForBuilding.push({
        className: 'cinema',
        name: 'Кинотеатр',
      });
    }

    if (infrastructureBuilding.hasNotaryOffice) {
      infrastructureForBuilding.push({
        className: 'notary_office',
        name: 'Нотариальная контора',
      });
    }

    if (infrastructureBuilding.hasRestaurant) {
      infrastructureForBuilding.push({
        className: 'restaurant',
        name: 'Ресторан',
      });
    }

    if (infrastructureBuilding.hasCafe) {
      infrastructureForBuilding.push({
        className: 'cafe',
        name: 'Кафе',
      });
    }

    if (infrastructureBuilding.hasPool) {
      infrastructureForBuilding.push({
        className: 'pool',
        name: 'Бассейн',
      });
    }
  }

  return infrastructureForBuilding;
}
